// import { useState, useCallback } from 'react';

const useGenerateQRCode = () => {
  return [];
};

export default useGenerateQRCode;
